import React, { createContext, useContext, useState, useEffect } from 'react';

const AdminAuthContext = createContext();

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used within an AdminAuthProvider');
  }
  return context;
};

export const AdminAuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [adminUser, setAdminUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Session-based authentication - backend'den session kontrolü
    const checkAuthStatus = async () => {
      try {
        const { checkAdminAuth } = await import('../utils/adminApi');
        const result = await checkAdminAuth();
        
        if (result.authenticated && result.user) {
          setIsAuthenticated(true);
          setAdminUser(result.user);
        } else {
          setIsAuthenticated(false);
          setAdminUser(null);
        }
      } catch (error) {
        console.error('Auth check error:', error);
        setIsAuthenticated(false);
        setAdminUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  const login = (userData) => {
    setIsAuthenticated(true);
    setAdminUser(userData);
  };

  const logout = async () => {
    try {
      // Backend'de session'ı temizle
      const { adminLogout } = await import('../utils/adminApi');
      await adminLogout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Frontend state'i temizle
      setIsAuthenticated(false);
      setAdminUser(null);
    }
  };

  const updateAdminUser = (userData) => {
    setAdminUser(prev => ({
      ...prev,
      ...userData
    }));
  };

  const value = {
    isAuthenticated,
    adminUser,
    loading,
    login,
    logout,
    updateAdminUser
  };

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
}; 